module.exports = __webpack_public_path__ + "img/5.b7fabcb5.png";